import Vue from 'vue'
import Router from 'vue-router'
import less from 'less'
Vue.use(less)

const index = r => require.ensure([], () => r(require('@/components/index.vue')), 'chunkname1')

import Vant from "vant";
import "vant/lib/index.css";

Vue.use(Vant);
Vue.use(Router)

export default new Router({
    routes: [{
            path: '/',
            name: 'index',
            component: index
        },

    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js